import "./App.css";
import { Switch } from "react-router-dom";
import { Router, Route} from "react-router-dom";

import { AuthProvider } from "./services/authContext";
import { history } from "./configureStore";
import { PrivateRoutingOptions, PublicRoutingOptions } from "./common/routes";
import { LayoutAuthenticated } from "./Routes/LayoutPrivate";
import { PrivateRoute } from "./Routes/PrivateRoute";
import { PublicRoute } from "./Routes/PublicRoute";
import { privateRoutes, publicRoutes } from "./Routes/Routes";
import { LayoutAnonymous } from "./Routes/LayoutPublic";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from 'mapbox-gl';

// Fix for Babel transpilation issue with mapbox-gl worker
// const workerUrl = new URL(
//   'mapbox-gl/dist/mapbox-gl-csp-worker.js', 
//   import.meta.url
// );
// @ts-ignore
mapboxgl.workerUrl = '/mapbox-gl-csp-worker.js';

function App() {
  return (
    <>
      <AuthProvider>
        <Router history={history}>
          <Switch>
            <Route exact path={PrivateRoutingOptions}>
                <LayoutAuthenticated>
                  <Switch>
                    {privateRoutes.map((privateRouteProps) => (
                      <PrivateRoute
                        {...privateRouteProps}
                        key={privateRouteProps.path}
                      />
                    ))}
                  </Switch>
                </LayoutAuthenticated>
            </Route>
            <Route exact path={PublicRoutingOptions}>
              <LayoutAnonymous>
                <Switch>
                  {publicRoutes.map((publicRouteProps) => (
                    <PublicRoute
                      {...publicRouteProps}
                      key={publicRouteProps.path}
                    />
                  ))}
                </Switch>
              </LayoutAnonymous>
            </Route>
          </Switch>
        </Router>
      </AuthProvider>
      </>
  );
}

export default App;
